import React from 'react';
import './style.css';
import { siteConfiguration } from 'siteConfig';
import { useLanguageContext } from 'context/LanguageProvider';

const Sponsors = () => {
	const { AllSponsor, sponsorProspectusText, sponsorProspectusActionButton } = siteConfiguration;
	const { currentLanguage } = useLanguageContext();
	return (
		<section className="sponsor-section">
			<div>
				<h2 className="sponsor-section-title">Sponsors</h2>
				<div className="sponsor-packages-wrapper">
					{AllSponsor.map((sponsorType, index) => {
						return (
							<div key={index} className="sponsor-package-container">
								<h3
									style={{
										color: `${sponsorType.color}`,
									}}
								>
									{sponsorType.package[currentLanguage]}
								</h3>
								<ul className="sponsors-logo-container">
									{sponsorType.sponsorsInfo.map((sponsor, index) => {
										return (
											<li
												className="sponsor-logo-wrapper"
												key={`sponsor-type-${index}`}
											>
												{sponsor.logo !== (null || undefined || '') ? (
													<a
														href={sponsor.url}
														target="_blank"
														rel="noreferrer"
													>
														<img
															src={sponsor.logo}
															alt={sponsor.name[currentLanguage]}
															className="sponsor-logo"
															title={sponsor.name[currentLanguage]}
														/>
													</a>
												) : (
													<div
														style={{
															width: '100px',
															height: '100px',
															display: 'flex',
															alignItems: 'center',
															justifyContent: 'center',
															border: '2px dashed #ccc',
															borderColor: `${sponsorType.color}`,
															borderRadius: '8px',
															color: `${sponsorType.color}`,
															fontSize: '14px',
														}}
													>
														{sponsor.name[currentLanguage]}
													</div>
												)}
											</li>
										);
									})}
								</ul>
							</div>
						);
					})}
				</div>

				<div className="prospectus-container">
					<p>{sponsorProspectusText[currentLanguage]}</p>
					<a href="/sponsor">{sponsorProspectusActionButton[currentLanguage]}</a>
				</div>
			</div>
		</section>
	);
};

export default Sponsors;
